module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("JUST ONE KISS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It wasn’t the photographer’s lights that were making Bridget warm and turning her cheeks pink. It was Jonas, standing under the mistletoe … waiting for her. In the cream-colored fisherman’s sweater and those worn jeans, he looked utterly masculine and sexier than any man had a right to be. Bridget was grateful that her daughter had left for a few minutes. If the photographer asked her to kiss Jonas, she didn’t know what she would do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go for it!” Gil said loudly. “Give the man a kiss. How can you resist?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She couldn’t. She couldn’t even think of a reason to refuse.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1f0390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm01.vue
// module id = 66
// module chunks = 0